import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const UnknownFileImage = (t0)=>{
    const $ = c(5);
    const { width, height } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.4064 5H32.5L45.9999 18.8V45.0115C45.9999 48.3218 43.1974 50.9999 39.7453 50.9999H16.2666C12.8025 50.9999 10 48.3218 10 45.0115V10.9884C9.99994 7.6781 12.9423 5 16.4064 5Z",
            fill: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M32.5289 14.384V5L45.9999 18.8L37.0192 18.8C32.9779 18.8 32.3418 15.856 32.5289 14.384Z",
            fill: "#BAC6D1"
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== height || $[3] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[2] = height;
        $[3] = width;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
export { UnknownFileImage };
